module.exports = __webpack_public_path__ + "static/media/trigger_soundi 5-2-Audio 1.15528d6f.mp3";